import { ApiMask, updateApiMask } from '../../../logger/BitMask';
import { Fetcher } from '../../Fetcher';

import { mainTableConfigParser } from './parser';
import type { IServerTableConfigResponse, ITableConfigParserOptions, TableConfigType } from './types';

export interface IFetchTableConfigParams {
  baseUrl: string;
  parserOptions: ITableConfigParserOptions;
  params: any;
}

export const fetchTableConfig = (params: IFetchTableConfigParams): Promise<TableConfigType> => {
  return fetchTableConfigJson(params);
};

const fetchTableConfigJson = ({
  baseUrl,
  params,
  parserOptions,
}: IFetchTableConfigParams): Promise<TableConfigType> => {
  const url = `${baseUrl}/api/ui/tableConfig`;

  return Fetcher.fetch<IServerTableConfigResponse | { errorCode: string | number; description: string }>(url, {
    params,
  })
    .then((response) => {
      if ('description' in response || 'errorCode' in response) {
        throw new Error(response.description || response.errorCode.toString());
      }

      return mainTableConfigParser({
        resResult: response,
        parseBetLimits: parserOptions.parseBetLimits,
        parsePayouts: parserOptions.parsePayouts,
      });
    })
    .then((parsedResponse) => {
      updateApiMask(ApiMask.TableConfig);
      return parsedResponse;
    });
};
